import { render, staticRenderFns } from "./SimilarNumbersPopup.vue?vue&type=template&id=cf1887c2&scoped=true"
import script from "./SimilarNumbersPopup.vue?vue&type=script&lang=ts"
export * from "./SimilarNumbersPopup.vue?vue&type=script&lang=ts"
import style0 from "./SimilarNumbersPopup.vue?vue&type=style&index=0&id=cf1887c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1887c2",
  null
  
)

export default component.exports